import React, { useContext } from 'react';
import { PhraseItem } from 'domains/designers/TruthTable/components';
import { RuleDesignerContext } from 'domains/designers/RuleDesigner/RuleDesignerContext';
import classNames from 'classnames';

export interface IVerbItemProps {
  evaluateWithNot?: boolean;
  verb: string;
  onVerbClick: (target: HTMLButtonElement) => void;
  verbClassName?: string;
}

/**
 * Represents a "verb" with "not"
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function VerbItem({ evaluateWithNot, verb, onVerbClick, verbClassName }: IVerbItemProps) {
  const { isDebug } = useContext(RuleDesignerContext);

  const handleVerbClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    !isDebug && onVerbClick?.(e.target as HTMLButtonElement);
  };

  const getClassName = (className?: string) => classNames('tt-verb-item', className);

  return (
    <>
      {evaluateWithNot && (
        <PhraseItem onClick={handleVerbClick} disabled={isDebug}>
          NOT
        </PhraseItem>
      )}
      <PhraseItem className={getClassName(verbClassName)} onClick={handleVerbClick} disabled={isDebug}>
        {verb}
      </PhraseItem>
    </>
  );
}
